import { getFormattedTodayCutoffTime } from '@/lib/utils'
import { useTotalMedicationRequests } from '@/services/dashboard'
import { borderRadius, colors, fontSizes } from '@/theme'
import { AccessTime } from '@mui/icons-material'
import { Paper, Typography, Skeleton } from '@mui/material'

export default function CutoffBanner() {
  const { data, isLoading, isError } = useTotalMedicationRequests()

  return (
    <Paper
      variant='outlined'
      sx={{
        p: 3,
        borderRadius: borderRadius.md,
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}
    >
      <AccessTime sx={{ color: colors.text.primary, fontSize: '24px' }} />
      <Typography sx={{ fontSize: fontSizes.lg, color: colors.text.primary }}>
        The cutoff for today is at{' '}
        {isLoading ? (
          <Skeleton width={65} height={25} sx={{ display: 'inline-block' }} />
        ) : isError ? (
          <strong>Unable to fetch cutoff time</strong>
        ) : (
          <strong>{getFormattedTodayCutoffTime(data!.cutoffTimes)}</strong>
        )}
      </Typography>
    </Paper>
  )
}
